export default __webpack_public_path__ + "static/media/188.d3ddd232.jpg";